/**
 * Load and play video on click
 *
 * @param {object} block
 */
const playVideo = ( block ) => {

	const button = block.querySelector( ".js-play-button" );
	const template = block.querySelector( ".js-video-template" );

	if ( button && template ) {

		button.addEventListener( "click", () => {

			const video = template.content.cloneNode( true );

			template.replaceWith( video );
			button.classList.add( "b-video__icon--hidden" );
			block
				.querySelector( ".b-video__video-image" )
				.classList.add( "b-video__video-image--hidden" );

		} );

	}

};

document.querySelectorAll( ".b-video" ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////

	playVideo( block );

} );
